import base from "/Users/maxbai/Downloads/monochrome-4f57e42d26760d51393bba8812babbedca3c9c02/images/google.svg?svg";
import { getParams, mergeSvgAttributes } from "svg-merge-attributes";
export default mergeSvgAttributes(base, getParams("size=22"));